import axios from "../../api/axiosInstance";

const BASE = process.env.REACT_APP_API_URL;

function toApiError(error, fallbackMessage) {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallbackMessage;
  const wrapped = new Error(message);
  wrapped.status = error?.response?.status;
  wrapped.cause = error;
  return wrapped;
}

export async function getConnectedProviders() {
  try {
    return await axios.get(`${BASE}/ai-provider-config`, { withCredentials: true });
  } catch (error) {
    throw toApiError(error, "Failed to fetch providers");
  }
}

export async function verifyAndSaveProvider(provider, apiKey) {
  try {
    return await axios.post(
      `${BASE}/ai-provider-config/verify-save`,
      { provider, apiKey },
      { withCredentials: true }
    );
  } catch (error) {
    throw toApiError(error, "Failed to verify and save provider key");
  }
}

export async function removeProvider(provider) {
  try {
    return await axios.delete(`${BASE}/ai-provider-config/${provider}`, {
      withCredentials: true,
    });
  } catch (error) {
    throw toApiError(error, "Failed to remove provider");
  }
}
